import { Component, OnInit } from '@angular/core';
import { ClientSummary, FreightMethod, PtdClientService, PtdDispatchService, DispatchClipboard } from 'coadapi';
import { Observable, of } from 'rxjs';
import { downloadSummaries } from '../proforma-to-dispatch/abstracts/_download-summaries';

@Component({
  selector: 'app-proforma-to-dispatch',
  templateUrl: './proforma-to-dispatch.component.html',
  styleUrls: ['./proforma-to-dispatch.component.scss'],
})
export class ProformaToDispatchComponent implements OnInit {

  constructor(
    private clientService: PtdClientService,
    private dispatchService: PtdDispatchService,
    private downloadSummaries: downloadSummaries
    ) {}
  public clientSummaries$: Observable<ClientSummary[]> = of([]);
  public dispatchClipboards$: Observable<DispatchClipboard[]> = of([]);

  ngOnInit() {
    this.clientSummaries$ = this.clientService.getAllClients();
    this.dispatchClipboards$ = this.dispatchService.getClipboardSummary();
  }

  methodShortName(method?: FreightMethod | null) {
    const methodName = method?.name ?? '';
    let matches = '';
    if (method?.methodId === 1) {
      matches = 'Air';
    } else if (method?.methodId === 2) {
      matches = 'Sea';
    } else if (method?.methodId === 4) {
      matches = methodName;
    } else if (method?.methodId === 70012) {
      matches = 'Virtual';
    } else if (method?.methodId === 70014) {
      matches = 'EXW';
    } else {
      matches = (methodName.match(/\b(\w)/g) ?? []).join('') || methodName;
    }

    return matches;
  }

  getReport() {
    this.downloadSummaries.getSummaries();
  }
}


